module.exports = __webpack_public_path__ + "img/Email_queue.739162d5.png";